"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderedInput = exports.forBorder = void 0;

var _reactEmotion = require("react-emotion");

var forBorder = function forBorder(_ref) {
  var color = _ref.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("padding:6px 6px;border-radius:2px;border:1px solid transparent;&:hover{border:1px solid ", color.grey1, ";}")
  );
};

exports.forBorder = forBorder;
var borderedInput =
/*#__PURE__*/
(0, _reactEmotion.css)("padding:6px 6px;");
exports.borderedInput = borderedInput;